/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalendarServiceTypeDto } from './calendarServiceTypeDto';
import { BusinessModelTypes } from './businessModelTypes';


export interface CalendarShopDto { 
    id?: number;
    name?: string | null;
    addressDisplay?: string | null;
    isOpen?: boolean;
    orderCount?: number;
    services?: Array<CalendarServiceTypeDto> | null;
    trayLimit?: number;
    businessType?: BusinessModelTypes;
    deliveryLocationEnabled?: boolean;
    mealAtPlaceEnabled?: boolean;
    mealAtPlaceDeliveryFromTime?: string | null;
    mealAtPlaceDeliveryToTime?: string | null;
    timeSlotDuration?: number | null;
    mealAtPlaceLocations?: string | null;
    notesEnabled?: boolean;
    canteenTimeSlotsEnabled?: boolean;
}
export namespace CalendarShopDto {
}


